// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperSelector-cls1_eVc","cls2":"PaperSelector-cls2_IZN PaperSelector-cls1_eVc"};